// Package labels.v3 defines the protocol buffer messages for label management
// within the platform. Labels are organizational resources that help users
// categorize and filter their assets, artifacts, and other content.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file labels/v3/label.proto (package labels.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { AuditMetadata } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Icon } from "../../common/v3/icons_pb";
import { file_common_v3_icons } from "../../common/v3/icons_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file labels/v3/label.proto.
 */
export const file_labels_v3_label: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v3_common, file_common_v3_icons, file_google_protobuf_timestamp]);

/**
 * Label represents a organizational tag that can be applied to assets, artifacts, and other resources.
 *
 * @generated from message labels.v3.Label
 */
export type Label = Message<"labels.v3.Label"> & {
  /**
   * Unique identifier for the label
   * Format: ^collection_[a-z0-9]{20}$
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Version number for optimistic concurrency control
   *
   * @generated from field: int64 version = 2;
   */
  version: bigint;

  /**
   * ETag for optimistic concurrency control
   *
   * @generated from field: string etag = 3;
   */
  etag: string;

  /**
   * Display name for the label (user-visible)
   *
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * Icon for the label
   *
   * @generated from field: common.v3.Icon icon = 5;
   */
  icon: Icon;

  /**
   * Color for the label (hex color code, e.g., "#FF5733")
   *
   * @generated from field: string color = 6;
   */
  color: string;

  /**
   * Description of the label
   *
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * Scope of the label (private, project, workspace, organization)
   *
   * @generated from field: labels.v3.LabelScope scope = 8;
   */
  scope: LabelScope;

  /**
   * ID of the tenant this label belongs to
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string tenant_id = 9;
   */
  tenantId: string;

  /**
   * ID of the organization this label belongs to (if scope is organization or below)
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: optional string organization_id = 10;
   */
  organizationId?: string;

  /**
   * ID of the workspace this label belongs to (if scope is workspace or below)
   * Format: ^workspace_[a-z0-9]{20}$
   *
   * @generated from field: optional string workspace_id = 11;
   */
  workspaceId?: string;

  /**
   * ID of the project this label belongs to (if scope is project)
   * Format: ^project_[a-z0-9]{20}$
   *
   * @generated from field: optional string project_id = 12;
   */
  projectId?: string;

  /**
   * Whether the label is archived (soft delete)
   *
   * @generated from field: bool is_archived = 13;
   */
  isArchived: boolean;

  /**
   * Usage count - how many resources are tagged with this label
   *
   * @generated from field: int64 usage_count = 14;
   */
  usageCount: bigint;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_used_at = 17;
   */
  lastUsedAt?: Timestamp;

  /**
   * Audit metadata
   *
   * @generated from field: common.v3.AuditMetadata audit_metadata = 18;
   */
  auditMetadata?: AuditMetadata;

  /**
   * Soft delete information
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 19;
   */
  deletedAt?: Timestamp;

  /**
   * Format: ^user_[a-z0-9]{20}$
   *
   * @generated from field: optional string deleted_by = 20;
   */
  deletedBy?: string;
};

/**
 * Describes the message labels.v3.Label.
 * Use `create(LabelSchema)` to create a new message.
 */
export const LabelSchema: GenMessage<Label> = /*@__PURE__*/
  messageDesc(file_labels_v3_label, 0);

/**
 * LabelAssociation represents the relationship between a label and a resource.
 *
 * @generated from message labels.v3.LabelAssociation
 */
export type LabelAssociation = Message<"labels.v3.LabelAssociation"> & {
  /**
   * Unique identifier for the association
   * Format: ^labelassoc_[a-z0-9]{20}$
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * ID of the label
   * Format: ^collection_[a-z0-9]{20}$
   *
   * @generated from field: string label_id = 2;
   */
  labelId: string;

  /**
   * ID of the resource being labeled
   *
   * @generated from field: string resource_id = 3;
   */
  resourceId: string;

  /**
   * Type of the resource being labeled (asset, artifact, chat, etc.)
   *
   * @generated from field: string resource_type = 4;
   */
  resourceType: string;

  /**
   * ID of the tenant this association belongs to
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string tenant_id = 5;
   */
  tenantId: string;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Audit metadata - who created this association
   *
   * @generated from field: common.v3.AuditMetadata audit_metadata = 7;
   */
  auditMetadata?: AuditMetadata;
};

/**
 * Describes the message labels.v3.LabelAssociation.
 * Use `create(LabelAssociationSchema)` to create a new message.
 */
export const LabelAssociationSchema: GenMessage<LabelAssociation> = /*@__PURE__*/
  messageDesc(file_labels_v3_label, 1);

/**
 * @generated from message labels.v3.LabelAssociationWithActions
 */
export type LabelAssociationWithActions = Message<"labels.v3.LabelAssociationWithActions"> & {
  /**
   * @generated from field: labels.v3.LabelAssociation association = 1;
   */
  association: LabelAssociation;

  /**
   * @generated from field: repeated string actions = 2;
   */
  actions: string[];
};

/**
 * Describes the message labels.v3.LabelAssociationWithActions.
 * Use `create(LabelAssociationWithActionsSchema)` to create a new message.
 */
export const LabelAssociationWithActionsSchema: GenMessage<LabelAssociationWithActions> = /*@__PURE__*/
  messageDesc(file_labels_v3_label, 2);

/**
 * LabelWithActions represents a label with the actions the current user can perform on it.
 *
 * @generated from message labels.v3.LabelWithActions
 */
export type LabelWithActions = Message<"labels.v3.LabelWithActions"> & {
  /**
   * The label
   *
   * @generated from field: labels.v3.Label label = 1;
   */
  label: Label;

  /**
   * Actions the current user can perform on this label
   *
   * @generated from field: repeated string actions = 2;
   */
  actions: string[];
};

/**
 * Describes the message labels.v3.LabelWithActions.
 * Use `create(LabelWithActionsSchema)` to create a new message.
 */
export const LabelWithActionsSchema: GenMessage<LabelWithActions> = /*@__PURE__*/
  messageDesc(file_labels_v3_label, 3);

/**
 * LabelSummary provides a lightweight representation of a label for lists and references.
 *
 * @generated from message labels.v3.LabelSummary
 */
export type LabelSummary = Message<"labels.v3.LabelSummary"> & {
  /**
   * Unique identifier for the label
   * Format: ^collection_[a-z0-9]{20}$
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Display name for the label
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * Icon for the label
   *
   * @generated from field: common.v3.Icon icon = 3;
   */
  icon: Icon;

  /**
   * Color for the label (hex color code)
   *
   * @generated from field: string color = 4;
   */
  color: string;

  /**
   * Scope of the label
   *
   * @generated from field: labels.v3.LabelScope scope = 5;
   */
  scope: LabelScope;

  /**
   * Usage count
   *
   * @generated from field: int64 usage_count = 6;
   */
  usageCount: bigint;
};

/**
 * Describes the message labels.v3.LabelSummary.
 * Use `create(LabelSummarySchema)` to create a new message.
 */
export const LabelSummarySchema: GenMessage<LabelSummary> = /*@__PURE__*/
  messageDesc(file_labels_v3_label, 4);

/**
 * LabelScope defines the scope and visibility of a label.
 *
 * @generated from enum labels.v3.LabelScope
 */
export enum LabelScope {
  /**
   * @generated from enum value: LABEL_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Label is private to the user who created it
   *
   * @generated from enum value: LABEL_SCOPE_PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * Label is scoped to a project
   *
   * @generated from enum value: LABEL_SCOPE_PROJECT = 2;
   */
  PROJECT = 2,

  /**
   * Label is scoped to a workspace
   *
   * @generated from enum value: LABEL_SCOPE_WORKSPACE = 3;
   */
  WORKSPACE = 3,

  /**
   * Label is scoped to an organization
   *
   * @generated from enum value: LABEL_SCOPE_ORGANIZATION = 4;
   */
  ORGANIZATION = 4,
}

/**
 * Describes the enum labels.v3.LabelScope.
 */
export const LabelScopeSchema: GenEnum<LabelScope> = /*@__PURE__*/
  enumDesc(file_labels_v3_label, 0);

